import axios from 'axios';
import { LAST_NAVTEX_API_URL, DRILL_FLEET_LAST_LOCATIONS_API_URL } from './constant';
export const ADD_USER = 'ADD_USER' // action types
export const IS_DATA_MENU_OPEN = 'IS_DATA_MENU_OPEN' // action types
export const SET_DATA_VISIBILITY_ARRAY = 'SET_DATA_VISIBILITY_ARRAY' // action types
export const SET_DATA_VISIBILITY_LIST = 'SET_DATA_VISIBILITY_LIST' // action types

export const GET_NAVTEX_INFO = 'GET_NAVTEX_INFO' // action types
export const NAVTEX_ERROR = 'NAVTEX_ERROR' // action types
export const SET_CHILDREN_LIST = 'SET_CHILDREN_LIST' // action types
export const INITIALIZE_SET_BOUND_FNC = 'INITIALIZE_SET_BOUND_FNC';
export const GET_DRILL_FLEET_LAST_LOCATIONS = 'GET_DRILL_FLEET_LAST_LOCATIONS'
export const DRILL_FLEET_LAST_LOCATIONS_ERROR = 'DRILL_FLEET_LAST_LOCATIONS_ERROR'

//! kullanmak lazım
export const SET_DRILL_FLEET_LAST_LOCATIONS = 'SET_DRILL_FLEET_LAST_LOCATIONS'

export function addUser(user) {
    return {
        type: ADD_USER,
        user
    }
}

export function setDataMenuStatus(newStatus) {
    return {
        type: IS_DATA_MENU_OPEN,
        newStatus
    }
}

export function setDataVisibilityArray(newDataSetArray) {
    return {
        type: SET_DATA_VISIBILITY_ARRAY,
        newDataSetArray
    }
}
export function setDataListVisibilityArray(newDataList) {
    return {
        type: SET_DATA_VISIBILITY_LIST,
        newDataList
    }
}
export function initializeSetBoundFnc(setBoundDelegate) {
    return {
        type: INITIALIZE_SET_BOUND_FNC,
        setBoundDelegate
    }
}

export const setNavtexList = () => async dispatch => {
    try {
        const res = await axios.get(LAST_NAVTEX_API_URL).then(res => {
            dispatch({
                type: GET_NAVTEX_INFO,
                payload: res.data//navtexList
            })
        })
    }
    catch (e) {
        dispatch({
            type: NAVTEX_ERROR,
            payload: console.log(e),
        })
    }
}

export const getDrillShipLastLocationsList = () => async dispatch => {
    try {
        const res = await axios.get(DRILL_FLEET_LAST_LOCATIONS_API_URL).then(res => {
            dispatch({
                type: GET_DRILL_FLEET_LAST_LOCATIONS,
                payload: res.data
            })
        })
    }
    catch (e) {
        dispatch({
            type: DRILL_FLEET_LAST_LOCATIONS_ERROR,
            payload: console.log(e),
        })
    }

}
export function setChildrenList(newChildrenList) {
    return {
        type: SET_CHILDREN_LIST,
        newChildrenList
    }
}


